//Built-in libraries

//Third party libraries
import { MapPinIcon } from '@heroicons/react/24/outline';
//services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';
//Assets and miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
//custom components
import Card from '../../UI/Card/index.tsx';
import LoadingMapCard from '../../UI/loading/Dashboard/LoadingMapCard';

import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';
import ProjectLocationMap from './ProjectLocationMap';

interface ProjectLocationWidgetProps {
  dashboard: DashboardType;
}

interface DashboardProjectLeadData {
  id: number;
  name: string;
  profileImageUrl: string;
}
export interface DashboardProjectByLocationInterface {
  id: number;
  name: string;
  address: string;
  location: any;
  city: string;
  state: string;
  zipCode: string;
  postalCode?: string;
  sources: { name: string; amount: number }[];
  squareFeet: number;
  lead?: DashboardProjectLeadData;
  path?: string;
}

const ProjectLocationWidget = ({ dashboard }: ProjectLocationWidgetProps) => {
  const fetchProjectLocationWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECT_LOCATION,
  });

  const projects = fetchProjectLocationWidgetData?.data?.data;

  return (
    <section>
      <WidgetLayout dashboard={dashboard} widget={Widget.PROJECT_LOCATION}>
        <Card title='Project Location'>
          {projects?.length === 0 && !fetchProjectLocationWidgetData.isLoading && (
            <div className='w-full flex justify-center items-center h-screen/2'>
              <div>
                <div className='flex justify-center items-center gap-2 text-primaryColor-normal'>
                  <MapPinIcon className='h-8 w-8' />
                  <h1>No Projects</h1>
                </div>
                <p>There are no assigned projects to display assigned to you as project lead</p>
              </div>
            </div>
          )}
          {fetchProjectLocationWidgetData.isLoading && <LoadingMapCard />}
          {projects && !fetchProjectLocationWidgetData.isLoading && (
            <div className='w-full grid grid-cols-6 h-screen/2'>
              <div className='col-span-6 w-full border-l p-5'>
                <ProjectLocationMap projectList={projects} />
              </div>
            </div>
          )}
        </Card>
      </WidgetLayout>
    </section>
  );
};

export default ProjectLocationWidget;
